export default class Cookies {
  get (cname) {
    let name = cname + '='
    let ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }
  set (name, value, options) {
    options = options || {}

    var expires = options.expires

    if (typeof expires === 'number' && expires) {
      var d = new Date()
      d.setTime(d.getTime() + expires * 1000)
      expires = options.expires = d
    }

    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString()
    }

    value = encodeURIComponent(value)

    var updatedCookie = name + (value !== 'undefined' ? '=' + value : '')

    for (var propName in options) {
      updatedCookie += '; ' + propName
      var propValue = options[propName]
      if (propValue !== true) {
        updatedCookie += '=' + propValue
      }
    }

    document.cookie = updatedCookie
  }
  delete (name) {
    this.set(name, '', {expires: -1})
  }
}



// WEBPACK FOOTER //
// ./src/common/cookies.js